import AGREGAR_SUBGRUPOS_OBRAS from '@/graphql/mutations/administracion/catalogos/subgrupos.obras/agregarCatalogoSubgrupoObra.gql';
import ACTUALIZAR_SUBGRUPOS_OBRAS from '@/graphql/mutations/administracion/catalogos/subgrupos.obras/actualizarCatalogoSubgrupoObra.gql';
import ELIMINAR_SUBGRUPOS_OBRAS from '@/graphql/mutations/administracion/catalogos/subgrupos.obras/removerCatalogoSubgrupoObra.gql';
import OBTENER_SUBGRUPOS_OBRAS from '@/graphql/querys/administracion/catalogos/subgrupos.obras/catalogoSubgruposObras.gql';

export default {
  apollo: {
    catalogoSubgruposObras: {
      query: OBTENER_SUBGRUPOS_OBRAS,
    },
  },
  methods: {
    async mixAgregarCatalogoSubgrupoObra() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: AGREGAR_SUBGRUPOS_OBRAS,
        variables: {
          catalogoSubgrupoObra: this.catalogoSubgrupoObra,
        },
        update: (store, { data: { agregarCatalogoSubgrupoObra } }) => {
          const data = store.readQuery({ query: OBTENER_SUBGRUPOS_OBRAS });
          data.catalogoSubgruposObras.push(agregarCatalogoSubgrupoObra);
          store.writeQuery({ query: OBTENER_SUBGRUPOS_OBRAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.mixEsCargando();
      this.enviandoFormulario = false;
    },
    async mixActualizarCatalogoSubgrupoObra() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_SUBGRUPOS_OBRAS,
        variables: {
          id: this.catalogoSubgrupoObraEditar.id,
          catalogoSubgrupoObra: this.catalogoSubgrupoObra,
        },
        update: (store, { data: { actualizarCatalogoSubgrupoObra } }) => {
          const data = store.readQuery({ query: OBTENER_SUBGRUPOS_OBRAS });
          const { catalogoSubgruposObras } = data;
          const index = catalogoSubgruposObras
            .findIndex(
              (catalogoSubgrupoObra) => catalogoSubgrupoObra.id
                === actualizarCatalogoSubgrupoObra.id,
            );
          if (index !== -1) {
            catalogoSubgruposObras.splice(index, 1, actualizarCatalogoSubgrupoObra);
          }
          store.writeQuery({ query: OBTENER_SUBGRUPOS_OBRAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.mixEsCargando();
      this.enviandoFormulario = false;
    },
    async mixEliminarCatalogoSubgrupoObra(id) {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ELIMINAR_SUBGRUPOS_OBRAS,
        variables: {
          id,
        },
        update: (store) => {
          const data = store.readQuery({ query: OBTENER_SUBGRUPOS_OBRAS });
          data.catalogoSubgruposObras = data.catalogoSubgruposObras
            .filter((catalogoSubgrupoObra) => catalogoSubgrupoObra.id !== id);
          store.writeQuery({ query: OBTENER_SUBGRUPOS_OBRAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.mixEsCargando();
      this.enviandoFormulario = false;
    },
  },
};
